// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"5fa73da8938481893157","678":"17312634fc2981901edc"}[chunkId] + ".js";
};